import { render, staticRenderFns } from "./pruebaURL.vue?vue&type=template&id=14d81027"
import script from "./pruebaURL.vue?vue&type=script&lang=js"
export * from "./pruebaURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports